import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent } from './ui/card';
import { CheckCircle } from 'lucide-react';

const WhyChooseUsSlider = ({ features }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className="why-choose-slider px-12">
      <Slider {...settings}>
        {features.map((feature, index) => {
          const Icon = feature.icon || CheckCircle;
          return (
            <div key={index} className="px-4">
              <Card className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 h-full overflow-hidden relative min-h-[280px]">
                {/* Background Image with Overlay */}
                {feature.backgroundImage && (
                  <div 
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${feature.backgroundImage})` }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-br from-[#1E1E1E]/85 via-[#1E1E1E]/80 to-[#E5B80B]/60 group-hover:from-[#1E1E1E]/90 group-hover:via-[#1E1E1E]/85 group-hover:to-[#E5B80B]/70 transition-all duration-300" />
                  </div>
                )}
                
                <CardContent className="p-8 relative z-10 flex flex-col h-full">
                  <div className="inline-block p-4 bg-[#E5B80B]/20 rounded-lg mb-6 w-fit group-hover:bg-[#E5B80B] transition-colors duration-300">
                    <Icon className="h-10 w-10 text-[#E5B80B] group-hover:text-[#1E1E1E] transition-colors duration-300" />
                  </div>
                  <h3 className="sub-heading mb-4 text-white">{feature.title}</h3>
                  <p className="body-regular text-gray-200 flex-grow">{feature.description}</p>
                </CardContent>
              </Card>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default WhyChooseUsSlider;
